import { generateHooks } from '@ucm-it/openapi-helpers';
import { BaseAPI, Configuration } from "@ucm-it/openapi-idm-js";
import { configuration } from "../apis/Configuration";

const { useApiController } = generateHooks<BaseAPI, Configuration>(configuration);

export {
    useApiController
}
